/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiNoteTemplateFromJSON(json) {
    return StreemApiNoteTemplateFromJSONTyped(json, false);
}
export function StreemApiNoteTemplateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'revisionNumber': !exists(json, 'revision_number') ? undefined : json['revision_number'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'createdByUserSid': !exists(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'lastUpdatedByUserSid': !exists(json, 'last_updated_by_user_sid') ? undefined : json['last_updated_by_user_sid'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'modifiedAt': !exists(json, 'modified_at') ? undefined : (new Date(json['modified_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiNoteTemplateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'company_sid': value.companySid,
        'revision_number': value.revisionNumber,
        'title': value.title,
        'text': value.text,
        'created_by_user_sid': value.createdByUserSid,
        'last_updated_by_user_sid': value.lastUpdatedByUserSid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'modified_at': value.modifiedAt === undefined ? undefined : (value.modifiedAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
//# sourceMappingURL=StreemApiNoteTemplate.js.map